const setupTab = (tabElement) => {
  tabElement.addEventListener('click', function() {
    if(!tabElement.classList.contains('active')){

      document.querySelector('[data-size-guide-tab].active').classList.remove('active');
      document.querySelector('[data-size-guide-content].active').classList.remove('active');

      document.querySelector(`#${tabElement.dataset.sizeGuideTab}`).classList.add('active');
      tabElement.classList.add('active');
    }
  });
}

const sizeChartTabs = () => {
  const tabs = document.querySelectorAll('[data-size-guide-tab]');
  if (!tabs) return false;
  tabs.forEach(tabElement => setupTab(tabElement));
}

export {
  sizeChartTabs,
};